/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Component, Input } from '@angular/core';
import { TooltipItem } from 'libs/sysque/toolbelt/data-access/src/lib/domain/tooltip-item';
import { IHTMLContent, ITooltip } from './sysque-tooltip-types';

@Component({
  selector: 'sysque-tooltip',
  templateUrl: './sysque-tooltip.component.html',
  styleUrls: ['./sysque-tooltip.component.scss'],
  standalone: false
})
export class SysqueTooltipComponent {
  @Input() tooltipData: ITooltip;

  public hasColor(tooltipItem: TooltipItem): boolean {
    return tooltipItem.header === 'Service Color' && tooltipItem.value !== '';
  }

  public getHtmlContent(tooltipItem: TooltipItem): IHTMLContent {
    const isSizesHeader = tooltipItem.header === 'Sizes';
    const isLeadLengthHeader = tooltipItem.header === 'Lead Length';
    const isBendRadiusHeader = tooltipItem.header === 'Bend Radii';
    const hasNonEmptyValue = tooltipItem.value !== null && tooltipItem.value !== '';
    const isSizeRelatedHeader = isSizesHeader || isLeadLengthHeader || isBendRadiusHeader;
    if (isSizeRelatedHeader && hasNonEmptyValue) {
      return { templateName: 'size', data: tooltipItem.valueAsArray };
    } else if (this.hasColor(tooltipItem)) {
      return { templateName: 'color', data: tooltipItem.value };
    } else {
      return { templateName: 'default', data: [tooltipItem.value] };
    }
  }

  public endsWith(d: string): boolean {
    if (Array.isArray(d)) {
      return;
    }
    return d.includes('*');
  }

  public slice(d: string, isLast: boolean): string {
    return isLast ? d : d + ',';
  }
}
